// ============================================================
// PHOTO SWAP FREEDOM — edit this file to change any photo on
// the landing page. Paste any image URL (Unsplash, your own
// hosted photos, etc.). Square face-cropped images look best.
// ============================================================

// The six orbiting galaxy nodes (keyed by node title).
export const GALAXY_PHOTOS = {
  "Speech": "https://images.unsplash.com/photo-1519457431-44ccd64a579b?w=96&h=96&fit=crop&crop=faces&q=80",
  "Math": "https://images.unsplash.com/photo-1588072432836-e10032774350?w=96&h=96&fit=crop&crop=faces&q=80",
  "Parent Assistant": "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=96&h=96&fit=crop&crop=faces&q=80",
  "Opportunities": "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=96&h=96&fit=crop&crop=faces&q=80",
  "Sound Safari": "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=96&h=96&fit=crop&crop=faces&q=80",
  "Quest Arcade": "https://images.unsplash.com/photo-1471286174890-9c112ffca5b4?w=96&h=96&fit=crop&crop=faces&q=80",
};

// Parent testimonial avatars (keyed by the parent's name).
export const TESTIMONIAL_PHOTOS = {
  "Danielle M.": "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=96&h=96&fit=crop&crop=faces&q=80",
  "Sarah C.": "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=96&h=96&fit=crop&crop=faces&q=80",
  "Mark T.": "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?w=96&h=96&fit=crop&crop=faces&q=80",
};

// Default testimonials — the admin "Landing photos" tab can override the
// quote, name, role and photo of each slot (stored in the backend).
export const DEFAULT_TESTIMONIALS = [
  { slot: "t1", quote: "Pip got my son practicing his R sound every single day — he asks for it.", name: "Danielle M.", role: "Mom of a 7-year-old" },
  { slot: "t2", quote: "Pip's speech coaching and gamified math turned screen time into genuine confidence for our 7-year-old.", name: "Sarah C.", role: "Mom of a 7-year-old" },
  { slot: "t3", quote: "The real-time parent digests give us complete visibility without hovering.", name: "Mark T.", role: "Dad of a 9-year-old" },
];
